import React, {useState, useReducer, useRef, useEffect, useCallback} from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import uuid from 'uuid';
import PropTypes from "prop-types";

import {getCurrentLayout} from "../../../../appLayout";
import ImageCanvasCommonNew from "../../../../visComponents/imageCanvasCommonNew";
import {getCurrentGroups, getFilteredLayersForActiveWizard, getWizardStepCommonCoords} from "./lookWizardFunctions";
import {getLayerCenter, zoomCanvasOut} from "../../lookFunctions";
import {setCanvasScale} from "../../../../../actions/actionFunctions";
import {useIsMounted} from "../../../../../misc/helperHooks";

const LookWizardContentCanvas = (props) => {

  const {wizardActiveItem, wizardActiveStep, wizardSelectedValues, setCanvasScale} = props;
  const [, setShowCanvasLoader] = useState(false);
  const [, forceUpdate] = useReducer(x => x + 1, 0);
  const [transform, setTransform] = useState("");
  const [canvasLoaded, setCanvasLoaded] = useState(false);

  const imageCanvas = useRef();
  const isMounted = useIsMounted();
  const timeoutRef = useRef(null);

  // safely update any state from async code/children
  const safeSetShowCanvasLoader = useCallback((val) => {
    if (isMounted()) setShowCanvasLoader(val);
  }, [isMounted]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, []);

  const updateLookCanvas = () => {
    if (isMounted()) {
      forceUpdate(1);
    }
  };

  const lookCanvasClick = () => {

  }

  useEffect(() => {
    let currentGroups = getCurrentGroups(wizardActiveItem, wizardActiveStep, wizardSelectedValues);
    if (!currentGroups.length) {
      currentGroups = getCurrentGroups(wizardActiveItem, 0, wizardSelectedValues)
        || wizardActiveItem.wizardGroups.filter(wizGroup => wizGroup.nodeType === "group");
    }
    // console.log("currentGroups", currentGroups, currentGroups[0]);
    const commonCoords = getWizardStepCommonCoords(currentGroups);
    // console.log("getWizardStepCommonCoords", commonCoords);
    if (commonCoords && imageCanvas && imageCanvas.current && imageCanvas.current.canvas) {
      const center = getLayerCenter(commonCoords, imageCanvas.current.canvas, false);
      // console.log("center", center);
      if (center) {
        const xMargin = center.clientWidth === center.x || center.x < 50 ? 18 : 10; // this is for very right wizards (LX-859 framing shower issue)
        setTransform(`scale(1) translate(${-center.featureX + xMargin}%, ${-center.y + 80}px)`)
      }
    } else {
      setTransform("scale(0.4) translate(0)");
    }

    if (wizardActiveStep > -1 && !currentGroups.length) {
      zoomCanvasOut(imageCanvas, setCanvasScale);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wizardActiveStep]);

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      if (isMounted()) setCanvasLoaded(true);
    }, 300);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const layout = getCurrentLayout();
  let layers = layout.getLayers(false);
  if (wizardActiveItem && wizardActiveItem.hideItems) {
    layers = getFilteredLayersForActiveWizard(wizardActiveItem, wizardSelectedValues, layers);
  }
  const layoutType = layout.getCurrentLayoutName();

  return (
    <div className={"lw-content__canvas" + (canvasLoaded ? " lw-content__canvas--loaded" : "") }>
      <ImageCanvasCommonNew layers={layers}
                            canvasId={uuid.v4()}
                            ref={imageCanvas}
                            lookCanvasClick={lookCanvasClick}
                            updateLookCanvas={updateLookCanvas}
                            layoutType={layoutType}
                            layout={layout}
                            layoutScene={layout.scene}
                            width={1920}
                            height={1080}
                            useMouseHovering={false}
                            useTouchZoom={true}
                            setShowCanvasLoader={safeSetShowCanvasLoader}
                            transform={transform}
      />
    </div>
  )
};

LookWizardContentCanvas.propTypes = {
  imageCanvas: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any })
  ]),
}

const mapStateToProps = (store) => {
  const {wizardActiveItem, wizardActiveStep, wizardSelectedValues} = store.wizardState;
  const {canvasCount} = store.bathroomVisualizerState;
  const {visualizersLoaded} = store.serverState;

  return {
    visualizersLoadedLength: visualizersLoaded.length,
    wizardActiveItem,
    wizardActiveStep,
    wizardSelectedValues,
    canvasCount,
  };
};

const mapDispatchToProps = {
  setCanvasScale
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LookWizardContentCanvas)
)
